import { SortChatsPipe } from '../../filters/sort-chats.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemNoContentComponent } from '../../components/item-no-content/item-no-content.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { CardChatComponent } from '../../components/card-chat/card-chat.component';
import { ItemChatComponent } from '../../components/item-chat/item-chat.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import ChatService from '../../services/chat.service';
import Session from '../../utils/session.service';
import Config from '../../utils/config.service';
import StatusService from '../../services/status.service';
import UrlUtil from '../../utils/url-util.service';
import RestService from '../../services/core-rest.service';
import Toast from '../../services/toast.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import RoutingService from '../../services/routing.service';
import { Subscription } from 'rxjs';
import $ from 'jquery';

@Component({
	standalone: true,
	selector: 'chats',
	templateUrl: './chats.component.html',
	imports: [
		CommonModule, SortChatsPipe, TranslatePipe, ItemNoContentComponent, 
		LoaderOverlayComponent, CardChatComponent, ItemChatComponent, FormsModule
	]
})
export default class ChatsView implements OnInit, OnDestroy {
	private chatService: ChatService = inject(ChatService);
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private statusService: StatusService = inject(StatusService);
	private urlUtil: UrlUtil = inject(UrlUtil);
	private restService: RestService = inject(RestService);
	private toast: Toast = inject(Toast);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	watcher: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('chats').then(() => {
			this.onResolve();
		});
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	onResolve() {
		var chats: any = this.chatService.getChats();
		if (chats) this.initializeChats(chats);
		if (!this.vm.chats) {
			this.vm.loaderTimeout = this.angularHelperService.createTimer(
				() => { this.vm.loading = true; }, this.config.getOtherConfig().LOADER_TIMEOUT_INIT);
		}
		
		// attempt reloading just in case a new chat was started from other views with chat buttons
		this.angularBroadcastHelperService.rootBroadcast(
			this.config.getBroadcastConfig().Session.INIT_CHAT, this.session.getSession()); 
		
		this.vm.user = this.session.getSession().user;

		this.vm.avTestUrl = this.urlUtil.createAvTestUrl();

		this.handleStatusUpdates(this.statusService.getStatuses());
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Chat.INIT,
				(event, chats) => { this.handleChatInit(event, chats); })
		);
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Chat.NEW,
				(event, chat) => { this.handleChatCreate(event, chat); })
		);
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Chat.DESTROY,
				(event, chat) => { this.handleChatRemove(event, chat); })
		);
		
		var currentPath;
		var currentStatuses = [];
		this.watcher = this.angularHelperService.createInterval(() => {
			var newCurrentPath = this.angularRoutingHelperService.getCurrentPath();
			if (newCurrentPath !== currentPath) {
				currentPath = newCurrentPath;
				this.angularRoutingHelperService.getCurrentPath();
			}
			
			var newStatuses = this.statusService.getStatuses();
			if (!this.angularHelperService.isEqual(newStatuses, currentStatuses)) {
				console.log("Statuses updated", currentStatuses, newStatuses);
				currentStatuses = newStatuses;
				this.handleStatusUpdates(newStatuses);
			}
		}, 300);
		
		this.vm.filterChats = this.filterChats;
		this.vm.selectChat = this.selectChat;
		this.vm.hasVisibleChats = this.hasVisibleChats;
		this.vm.getChatsFiltered = this.getChatsFiltered;
		
		this.vm.isMentalHealthServiceStatusLoaded = false;
		var currentSession = this.session.getSession();
		this.vm.isMentalHealthServiceProvider = currentSession.user
			&& currentSession.user.service
			&& currentSession.user.service.mentalHealthServiceProvider;
		if (this.vm.isMentalHealthServiceProvider) {
			this.getMentalHealthServiceProviderStatus();
		}
		this.vm.activateMentalHealthServiceProvider = this.activateMentalHealthServiceProvider;
		this.vm.deActivateMentalHealthServiceProvider = this.deActivateMentalHealthServiceProvider;
	}
	
	selectChat(chat) {
		if (!chat || !chat.id) {
			this.vm.selectedChat = undefined;
			if (this.angularRoutingHelperService.getCurrentPath() !== 'chats') this.angularRoutingHelperService.setPath('chats', false);
			return;
		}
		var id: any = this.angularRoutingHelperService.getRouteParam('id');
		if (id != chat.id) {
			this.angularRoutingHelperService.setPath(['chats/', chat.id], false);
		}
		if (!this.vm.selectedChat || id != chat.id) {
			this.vm.selectedChat = chat;
		}
	}
	
	filterChats() {
		return (item) => {
			if (!this.vm.term) return true;
			return item.privateChatFriend.fullName.toLowerCase().indexOf(this.vm.term.toLowerCase()) >= 0;
		};
	}
	
	getChatsFiltered() {
		if (this.vm.chats) {
			var filtered: Array<any> = [];
			this.angularHelperService.forEach(this.vm.chats, (item) => {
				filtered.push(item);
			});
			return filtered.filter(this.filterChats());
		} else {
			return [];
		}
	}
	
	hasVisibleChats() {
		var chatsFiltered: any = this.getChatsFiltered();
		return chatsFiltered && chatsFiltered.length > 0;
	}
	
	getMentalHealthServiceProviderStatus() {
		this.restService.getMentalHealthServiceProviderStatus()
		.then((response) => {
			if (response && response.id) {
				this.vm.mentalHealthServiceProviderActive = response.active;
			} else {
				this.vm.mentalHealthServiceProviderActive = false;
			}
			this.vm.isMentalHealthServiceStatusLoaded = true;
		})
		.catch((error) => {
			this.vm.mentalHealthServiceProviderActive = false;
			console.log(error);
		});
	}
	
	activateMentalHealthServiceProvider() {
		this.vm.isMentalHealthServiceStatusLoaded = false;
		this.restService.saveActivateMentalHealthServiceProvider()
			.then((response) => {
				if (response && response.id) {
					this.vm.mentalHealthServiceProviderActive = response.active;
				} else {
					this.vm.mentalHealthServiceProviderActive = false;
				}
				this.vm.isMentalHealthServiceStatusLoaded = true;
				this.toast.showAsync(this.angularFilterHelperService.translate('Chats.Other.MentalHealthServiceActivated'),
					this.angularFilterHelperService.translate('Common.Got_It'), 6000);
			})
			.catch((error) => {
				console.log(error);
			});
	}
	
	deActivateMentalHealthServiceProvider() {
		this.vm.isMentalHealthServiceStatusLoaded = false;
		this.restService.saveDeactivateMentalHealthServiceProvider()
		.then((response) => {
			if (response && response.id) {
				this.vm.mentalHealthServiceProviderActive = response.active;
			} else {
				this.vm.mentalHealthServiceProviderActive = false;
			}
			this.vm.isMentalHealthServiceStatusLoaded = true;
			this.toast.showAsync(this.angularFilterHelperService.translate('Chats.Other.MentalHealthServiceDeactivated'),
				this.angularFilterHelperService.translate('Common.Got_It'), 6000);
		})
		.catch((error) => {
			console.log(error);
		});
	}
	
	initializeChats(chats) {
		this.vm.chats = chats;

		var routeChatId: any = this.angularRoutingHelperService.getRouteParam('id');
		var id: any = routeChatId || Object.keys(this.vm.chats || {})[0];
		if (!id || !this.vm.chats) {
			this.angularHelperService.createTimer(() => { this.vm.initialized = true; });
			return;
		}
		
		if (this.vm.selectedChat && id && this.vm.selectedChat.id == id) {
			this.angularHelperService.createTimer(() => { this.vm.initialized = true; });
			return;
		}
		
		var chat: any = this.vm.chats[id];
		if (chat) {
			var w: any = $(window).width();
			var isSmallSizeWindow = (w ? w <= 768 : false);
			var hasChatId: any = this.angularRoutingHelperService.getCurrentPath().split('/').length > 1;
			if (!isSmallSizeWindow || hasChatId) {
				this.selectChat(chat);
			}
			this.angularHelperService.createTimer(() => { this.vm.initialized = true; });
			return;
		}
		
		this.angularHelperService.createTimer(() => { this.vm.initialized = true; });
		// A newly created chat can reach this view before the chat cache is updated.
		// Keep its deep link so the matching Chat.NEW/Chat.INIT event can select it.
		if (!routeChatId) this.angularRoutingHelperService.setPath('chats', false, true);
	}
	
	handlePathChange(path) {
		this.angularHelperService.createTimer(() => {
			if (path.indexOf('chats') === -1) return;
			var id: any = path.split('chats/')[1];
			var chats: any = this.vm.chats || [];
			this.vm.selectedChat = id ? chats[id] : undefined;
		});
	}
	
	handleChatInit(event, chats) {
		this.handleChatInitInternal(event, chats);
	}
	
	handleChatInitInternal(event, chats) {
		this.initializeChats(chats);
		if (this.vm.loaderTimeout) this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
		if (this.vm.loading) this.angularHelperService.createTimer(
			() => { this.vm.loading = false; },
			this.config.getOtherConfig().LOADER_TIMEOUT_DELAY
		);
	}
	
	handleChatRemove(event, chat) {
		delete this.vm.chats[chat.id];
	}
	
	handleChatCreate(event, chat) {
		this.vm.chats = this.vm.chats || {};
		this.vm.chats[chat.id] = chat;
		// removed auto activating new chat since it can cause issues 
		// like typing into wrong chat or chat info lost if multiple new chats incoming
		// A chat explicitly requested by the current route is safe to activate.
		var routeChatId: any = this.angularRoutingHelperService.getRouteParam('id');
		if (routeChatId && routeChatId == chat.id) this.selectChat(chat);
	}
	
	handleStatusUpdates(statuses) {
		this.angularHelperService.forEach(this.vm.chats, (chat) => {
			var id: any = chat.privateChatFriend.id;
			if (statuses[id]) chat.privateChatFriend.status = statuses[id].status;
		});
	}
	
}
